import React from 'react';
import '../../assets/css/Inicio.css';
import Desktop from '../../assets/images/desktop.svg';
import Mobile from '../../assets/images/desktop-mobile.svg';
import Header from '../nav/Header';
import Title from '../nav/Title';
import Footer from './Footer';
import { Link  } from "react-router-dom";


const Inicio = () => {
  return (
   
     <div>
    <Title title='Inicio' />
      <body id="inicio">
      <Header/>
        <main className="container">
        <div className="row">
            <div className="col-12 col-sm-12 ">
                <div className="m-4 text-center my-4 ">
                <Link to="/proyectos" className="d-inline-block" ><img className="computer d-none d-sm-block col-sm-12" src={Desktop} alt="computer"/></Link>
                <Link to="/proyectos" className="d-inline-block" ><img className="mobile d-block d-sm-none col-sm-12" src={Mobile} alt="computer"/></Link>
                </div>
                <div className="text-center col-12  d-flex justify-content-center">
                    <div className="texto mt-1">
                        <p className="col-12 py-1 px-4">Bienvenid@ a mi sitio web sobre sistemas.</p>
                    </div>
                </div>
                <div className="btn-violet text-center mb-3">
                    <a href="proyectos.php">Conoce mis proyectos</a>
                </div>
            </div>
        </div>
        </main>
        <Footer/>
      </body>
    </div> 
    
    
  )
  
}

export default Inicio
